import React from 'react';
import { applicationStatus } from '../../utils/enums';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCell from '@material-ui/core/TableCell';
import { titleCase } from '../../utils/string';

const useStyles = makeStyles((theme: any) => ({
  root: {
    color: ({ status }: any) => {
      switch (status) {
        case applicationStatus.archived.status:
          return theme.palette.error.main;
        case applicationStatus.submitted.status:
          return 'orange';
        case applicationStatus.review.status:
          return 'orange';
        case applicationStatus.rejected.status:
          return theme.palette.status.rejected;
        case applicationStatus.pending.status:
          return theme.palette.primary.main;
        case applicationStatus.active.status:
          return theme.palette.status.active;
        case applicationStatus.complete.status:
          return theme.palette.status.complete;
        default:
          return theme.palette.grey[400];
      }
    },
  },
  status: {
    marginRight: theme.spacing(0.5),
  },
}));

export default function Status({ status, statusExpirationText }) {
  const classes = useStyles({ status });
  const isPending = status === applicationStatus.pending.status;

  if (isPending) {
    status = 'ready';
  }

  return (
    <TableCell className={classes.root}>
      {<span className={classes.status}>{titleCase(status)}</span>}
      {statusExpirationText && isPending && <span>{statusExpirationText}</span>}
    </TableCell>
  );
}
